module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Light.67bc9f4f.ttf";